module.exports = __webpack_public_path__ + "be6d7c28243a9103cb207c47699daaf5.svg";